import { forwardRef } from 'react'
import { FitpetIcon, FitpetIconName } from '@fitpet/ui/components/fitpet-icon'
import clsx from 'clsx'
import styles from '@/components/domains/layouts/header/fitpet-title-header.module.css'
import useCustomRouter from '@/containers/hooks/useCustomRouter'

export interface TitleHeaderProps {
  isShowBackButton?: boolean
  onLeftIconClick?: () => void
  title: string
  rightNode?: React.ReactNode
  iconType?: FitpetIconName
  callback?: () => void
  position?: 'static' | 'relative' | 'fixed' | 'absolute' | 'sticky'
  className?: string
  backgroundColor?: string
}

export const FitpetTitleHeader = forwardRef<HTMLDivElement, TitleHeaderProps>(
  (
    {
      isShowBackButton = true,
      onLeftIconClick,
      title,
      rightNode,
      position = 'relative',
      className,
      iconType = 'icBack',
      callback,
      backgroundColor,
    },
    ref
  ) => {
    const router = useCustomRouter()

    const handleBackIconClick = () => {
      if (onLeftIconClick) {
        onLeftIconClick()
      } else {
        router.back()
      }

      if (callback) {
        callback()
      }
    }

    return (
      <div>
        <div
          className={clsx(styles.container, className, backgroundColor ? '' : 'gray-white')}
          style={{
            position: position,
            backgroundColor: backgroundColor,
          }}
          ref={ref}
        >
          {isShowBackButton && (
            <div className={styles.backIconWrapper} onClick={handleBackIconClick} data-testid="back-icon">
              <FitpetIcon icon={iconType} size={24} color="var(--gray-900)" />
            </div>
          )}
          <div className={clsx(styles.titleWrapper, 'font-heading6-bold gray-900')}>{title}</div>
          {rightNode && <div className={styles.rightNodeContainer}>{rightNode}</div>}
        </div>
      </div>
    )
  }
)

FitpetTitleHeader.displayName = 'FitpetTitleHeader'
